module.exports = __webpack_public_path__ + "static/media/Logo-Shape.bff06e11.png";